import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/lib/fonts.js\",\"import\":\"Poppins\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"200\",\"300\",\"400\",\"500\",\"600\",\"700\"]}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/context/apollo/ApolloProvider.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/vercel/path0/src/context/auth/AuthProvider.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/context/deliveryApp/DeliveryAppProvider.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/context/mainLayout/MainLayoutProvider.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["SwitchThemeProvider"] */ "/vercel/path0/src/context/theme/SwitchThemeProvider.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/globals.css");
